import {
  LOAD_DEVICE_EVENTS,
  unloadDeviceEventsAction,
} from "fleet/redux-store/ui-state/device-events/actions";
import { deviceEventsSelector } from "fleet/redux-store/ui-state/device-events/selectors";
import { DeviceTimeline } from "fleet/view/event/timeline";
import { connect } from "react-redux";
import { defaultObject, makeGetAllAsArray } from "redux-store";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { storesReady } from "redux-store/utils";

const getAllEventsAsArray = makeGetAllAsArray();

function mapStateToProps(state, props) {
  const events = deviceEventsSelector(state).events || defaultObject;
  const storesLoaded = storesReady(state.global.devices);
  return {
    events: getAllEventsAsArray({ byId: events }),
    storesLoaded,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchTimeline: (serviceArgs) => {
      const { deviceId, firstEventId, lastEventId } = serviceArgs;
      const eventIds = [firstEventId, lastEventId].filter((eid) => eid);
      return createPromiseApiAction(dispatch, LOAD_DEVICE_EVENTS, [
        deviceId,
        ...eventIds,
      ]);
    },
    unloadTimeline: () => {
      return dispatch(unloadDeviceEventsAction);
    },
  };
}

const ConnectedDeviceTimeline = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeviceTimeline);

export { ConnectedDeviceTimeline };
